import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { getCurrentUser } from "aws-amplify/auth";
import "./global.css";

/* -----------------------------
   ADMIN NAVBAR
----------------------------- */
import AdminNavbar from "./admin/components/AdminNavbar";

/* -----------------------------
   ADMIN PAGES
----------------------------- */
import AdminLogin from "./admin/AdminLogin";
import AdminHome from "./admin/AdminHome";
import UploadCSV from "./admin/UploadCSV";
import EnterManual from "./admin/EnterManual";
import ViewPage from "./admin/ViewPage";
import Recents from "./admin/Recents";
import EditPage from "./admin/EditPage";
import DownloadPage from "./admin/DownloadPage";
import AdminLayout from "./admin/layout/AdminLayout";


/* -----------------------------
   AUTH (FORGOT / RESET)
----------------------------- */
import ForgotPassword from "./admin/ForgotPassword";
import ResetPassword from "./admin/ResetPassword";

/* -----------------------------
   PUBLIC PAGES
----------------------------- */
import PublicSearch from "./public/PublicSearch";
import Maintenance from "./public/Maintenance";
import Track from "./public/Track";
import Status from "./public/Status";



/* -----------------------------
   PROTECTED ROUTE WRAPPER
----------------------------- */
function ProtectedRoute({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    getCurrentUser()
      .then((u) => setUser(u))
      .catch(() => setUser(null));
  }, []);

  if (user === undefined) return null; // still checking auth
  if (user === null) return <Navigate to="/admin/login" replace />;

  return children;
}


/* -----------------------------
   MAIN APP WRAPPER
----------------------------- */
function AppWrapper() {
  const location = useLocation();

  // Show navbar on /admin/* except these:
  const hideNavRoutes = [
    "/admin/login",
    "/admin/forgot-password",
    "/admin/reset-password"
  ];

  const isAdminRoute = location.pathname.startsWith("/admin");
  //const shouldShowNavbar = isAdminRoute && !hideNavRoutes.includes(location.pathname);
  const shouldShowNavbar = false; // TEMPORARY: hide old navbar


  return (
    <>
      {shouldShowNavbar && <AdminNavbar />}

      <div style={{ marginTop: shouldShowNavbar ? "80px" : "0px" }}>
        <Routes>

          {/* ---------------- MAINTENANCE MODE ---------------- */}
          {/* Set MAINTENANCE_MODE to true to show maintenance page */}
          {true && <Route path="*" element={<Maintenance />} />}

          {/* ---------------- PUBLIC ROUTES ---------------- */}
         <Route path="/" element={<PublicSearch />} />
          <Route path="/maintenance" element={<Maintenance />} />

          <Route path="/track" element={<Track />} />
          <Route path="/status" element={<Status />} />

          {/* ---------------- AUTH ROUTES ---------------- */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot-password" element={<ForgotPassword />} />
          <Route path="/admin/reset-password" element={<ResetPassword />} />

          {/* ---------------- ADMIN PROTECTED ROUTES ---------------- */}
        <Route
  path="/admin/*"
  element={
    <ProtectedRoute>
      <AdminLayout />
    </ProtectedRoute>
  }
/>


        </Routes>
      </div>
    </>
  );
}


/* -----------------------------
   MAIN APP EXPORT
----------------------------- */
export default function App() {
  return (
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
  );
}